import { PromotionRewardTarget } from '../RegistrationOfferImage/RegistrationOfferImage.constants';
import { z } from '@bonanza-social/toolkit/api';
import icons from '@bonanza-social/moonlight/lib/assets/icons';
import { PromoTargetSchema } from '@bonanza-social/promos';

export const rewardBadgeMap: Partial<
  Record<z.infer<typeof PromoTargetSchema>, keyof typeof icons>
> = {
  FreeSpins: 'freeSpins',
  Coins: 'bonanzaCoin',
  InstantWheel: 'rewardWheel',
  Cash: 'bonanzaDollar',
  Wheel: 'metaWheel',
  Scratcher: 'scratchcards',
  Bonus: 'bonanzaDollar',
};

export const rewardBadgeDataMap = {
  [PromotionRewardTarget.FreeSpins]: {
    iconName: rewardBadgeMap.FreeSpins,
    rewardName: 'Free Spins',
  },
  [PromotionRewardTarget.Coins]: {
    iconName: rewardBadgeMap.Coins,
    rewardName: 'Bonanza Coins',
  },
  [PromotionRewardTarget.InstantWheel]: {
    iconName: rewardBadgeMap.InstantWheel,
    rewardName: 'Wheel Spins',
  },
  [PromotionRewardTarget.Cash]: {
    iconName: rewardBadgeMap.Cash,
    rewardName: 'Cash',
  },
  [PromotionRewardTarget.Bonus]: {
    iconName: rewardBadgeMap.Bonus,
    rewardName: 'Bonus',
  },
  [PromotionRewardTarget.Scratcher]: {
    iconName: rewardBadgeMap.Scratcher,
    rewardName: 'Scratchcards',
  },
};
